import { useCore } from "@spectral-finance/react-core";
import React, { useState } from "react";
import SpectralLogo from "../../../../assets/spectral.svg";
import WalletLogo from "../../../../assets/wallet.svg";
import {
  DialogSteps,
  useDialogStepsContext,
} from "../../../../contexts/DialogStepsContext";
import useMediaQuery from "../../../../hooks/useMediaQuery";
import { shortenAddress } from "../../../../utils";
import { AddMoreWallets } from "../../../AddMoreWallets";
import Flex from "../../../Flex";
import { RightArrowIcon } from "../../../Icon/icons/RightArrow";
import { OverlapLogos } from "../../../OverlapLogos";
import { ScoreLoader } from "../../../ScoreLoader";
import { SpectralButton } from "../../../SpectralButton";
import { WalletConnected } from "../../../WalletConnected";
import * as SC from "./Bundle.styles";

/* If more than 1 wallet is connected, the following items needs to disappear:
  - AddMoreWalletsDescription
  - Divider
  - SpectralButton: remove the 'generate score' label
  - SpectralButton: width must match height to become a circle button
  */

export const Bundle = () => {
  const { setCurrentStep } = useDialogStepsContext();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const { account, bundle, score } = useCore();
  const [loadingScore, setLoadingScore] = useState<boolean>(false);
  const minBundle =
    !!bundle?.bundle?.primaryAddress &&
    bundle?.bundle?.secondaryAddresses?.length === 0;

  const calculateScore = async () => {
    console.log("Calculating score...");
    setLoadingScore(true);
    await score.getWalletScore();
    console.log("Score calculated!");
    setCurrentStep(DialogSteps.SUCCESS);
  };

  if (loadingScore) {
    return <ScoreLoader />;
  }

  const minted = account.minted
  const usedBundle = minted ? account.bundle : bundle.bundle


  return (
    <SC.BundleContainer>
      <Flex width="100%" column align="center" justify="center">
        <OverlapLogos topImage={SpectralLogo} backImage={WalletLogo} />
        <h1>{minted ? `We've detected a bundle` : 'Add more wallets to your bundle'}</h1>
        {!minted && <SC.BundleText>
          Increasing your transaction history would give the lender more
          information about your application
        </SC.BundleText>}

        <SC.BundleList>
          {usedBundle && !minted && (
            <>
              <WalletConnected
                key={shortenAddress(usedBundle.primaryAddress)}
                address={usedBundle.primaryAddress}
                signed
              />
              {usedBundle.secondaryAddresses?.map((walletConnected) => (
                <WalletConnected
                  key={shortenAddress(walletConnected)}
                  address={walletConnected}
                  signed
                />
              ))}
            </>
          )}
          {usedBundle && minted && (
            <WalletConnected
              title={usedBundle.name}
              addresses={[usedBundle.primaryAddress, ...usedBundle.secondaryAddresses]}
              signed
            />
          )}
        </SC.BundleList>

        {usedBundle && !minted && (
          <AddMoreWallets flat />
        )}

        {usedBundle && !minted && (
          <>
            <SC.Divider />
            <SC.AddMoreWalletsDescription>
              Each time you add a new wallet you will be asked to sign a
              transaction in order to verify ownership of the wallet.
            </SC.AddMoreWalletsDescription>
          </>
        )}

        <SC.BundleButtonWrapper width="100%" align="center" justify="end">
          <SpectralButton
            width={isMobile ? "100%" : minBundle || minted ? "" : "56px"}
            height="56px"
            label={
              <>
                {minted ? 'Continue' : minBundle && <>Generate score</>}{" "}
                <RightArrowIcon color="var(--white)" />
              </>
            }
            onClick={calculateScore}
          />
        </SC.BundleButtonWrapper>
      </Flex>
    </SC.BundleContainer>
  );
};
